import { buildSeedMailRoutes, topicToMailRouteKey } from './accessControlConstants'

let mailRoutesCache = buildSeedMailRoutes()

export const setMailRoutesCache = (routes) => {
  if (routes && typeof routes === 'object') {
    mailRoutesCache = { ...buildSeedMailRoutes(), ...routes }
  }
}

export const getMailRoutesCache = () => mailRoutesCache

/** sendMail için: { to: string[], cc: string[] } */
export const resolveMailRouteForTopic = (topic) => {
  const key = topicToMailRouteKey(topic)
  const route = mailRoutesCache[key] || mailRoutesCache.default || { to: [], cc: [] }
  return {
    to: Array.isArray(route.to) ? [...route.to] : [],
    cc: Array.isArray(route.cc) ? [...route.cc] : [],
  }
}
